import React from 'react'
import { Box, Divider, Typography } from "@mui/material"


export default function comparatorColumn(name, label, hideFilters = false) {

	return [{
		name: name,
		label: label,
		options: {
			filter: !hideFilters,
			display: 'excluded',
			customBodyRowRender: ({ main }) => {
				return main
			}
		}
	}
		, {
			name: name,
			label: label,
			options: {
				filter: false,
				customBodyRowRenderLite: ({ main, competitor }) => {
					return <Box sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						flexDirection: "column"
					}}>
						<Typography sx={{ fontWeight: "bold", textAlign: "center" }}>{!!main && main}</Typography>
						{!!competitor && <>
							<Divider sx={{ my: 1, width: "80%", borderBottom: "2px solid" }}/>
							<Typography sx={{ textAlign: "center" }}>{competitor}</Typography>
						</>}
					</Box>
				}
			}
		}]
}